<template>
  <div
    class="option d-flex flex-column justify-content-around align-items-center"
    @click="selected"
  >
    <div class="text-center w-100">{{optionText}}</div>
    <img class="button-image m-2" :class="this.sizeClass" :src="picture" />
  </div>
</template>
<script>
export default {
  name: 'PictureAnswer',
  props: {
    optionName: { type: String },
    optionText: { type: String },
    optionPicture: { type: String },
    optionSize: { type: String },
    optionValue: {},
  },
  data() {
    return {};
  },
  computed: {
    picture() {
      const images = require.context('@/images');
      return this.optionPicture
        ? images(`./${this.optionPicture}`)
        : 'https://via.placeholder.com/150';
    },
    sizeClass() {
      return `option-${this.optionSize}`;
    },
  },

  methods: {
    selected() {
      this.$emit('optionSelected', {
        selectedOption: this.optionName,
        selectedValue: this.optionValue,
      });
    },
  },
};
</script>
<style scoped>
.button-image {
  width: 80%;
  min-width: 40px;
}
.option:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 158, 226, 0.2),
    0 6px 20px 0 rgba(0, 158, 226, 0.19);
  transition: ease-in;
  transition-duration: 400ms;
  border-color: navy;
  color: navy;
}

.option {
  display: inline-block;
  border: #000000 solid 1px;
  border-radius: 5px;
  margin: 15px;
  padding: 10px;

  min-width: 80px;
  max-width: 400px;

  align-items: flex-start;
}

.option-larger {
  max-width: 150px;
}

.option-smaller {
  max-width: 50px;
}
</style>
